export default "__VITE_ASSET__BPPeq1NV__"